import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { INzMessageType } from '@ascschool/interface/setting';
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { CertificateOfStaff } from '@ascschool/model/user/certificate-of-staff.model';
import { DiplomasService } from '@ascschool/services/category/diplomas.service'; 
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-popup-them-chung-chi',
  templateUrl: './popup-them-chung-chi.component.html',
  styleUrls: ['./popup-them-chung-chi.component.scss']
})
export class PopupThemChungChiComponent implements OnInit {
  validateForm =  new FormGroup({
    disCertificateOfStaffName: new FormControl('', Validators.required),
    disCertificateOfStaffCourse: new FormControl('', Validators.required),
    studyTime: new FormControl('', Validators.required),
    note: new FormControl(''),
    diplomaId: new FormControl(''),
  });
  @Input() value: any;
  itemChungChi: CertificateOfStaff = new CertificateOfStaff();
  response: CustomResponse = new CustomResponse();
  isEditMode = false;
  errorMsg: string;
  isDisabled = false;
  getDiplomaACFn: (value: any) => Observable<any>;
  DiplomaSubscription: any;
  DiplomaControl = this.validateForm.controls.diplomaId;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    public diplomaService: DiplomasService,
  ) {
  }

  ngOnInit() {
    if (this.value && this.value.diplomaId.id > 0) {
      this.value.diplomaId = this.value.diplomaId.id;
      this.validateForm.controls.disCertificateOfStaffName.setValue(this.value.disCertificateOfStaffName)
      this.validateForm.controls.disCertificateOfStaffCourse.setValue(this.value.disCertificateOfStaffCourse);
      this.validateForm.controls.studyTime.setValue(this.value.studyTime);
      this.validateForm.controls.note.setValue(this.value.note);
      this.GetById(this.value.diplomaId);
    }
    this.loadDiploma();
  }
  GetById(id: number) {
    this.diplomaService.getById(id).subscribe(res =>{
      this.DiplomaControl.setValue({id: res.id , text: res.diplomaName});
    })
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose(){
    if (this.validateForm.valid){ 
      this.itemChungChi.diplomaName = this.DiplomaControl.value.text;
      this.response.data = this.validateForm.value;
      this.response.status = true;
      this.modal.close(this.response);
      this.utilsService.showNotification(INzMessageType.Success, 'Thành công', 1000);
    }
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  loadDiploma() {
    this.getDiplomaACFn = (value: any) => this.diplomaService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.diplomaName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DiplomaSubscription) { this.DiplomaSubscription = this.DiplomaControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemChungChi, 'diplomaId', this.DiplomaControl.value);
    });
    }
  }
  changeDiploma(control: FormControl) {
    this.DiplomaControl = control;
  }
}
